export const data = [
	{
		icon: "fa-solid fa-bolt",
		title: "Snappy Process",
		desc: "Our application process can be completed in minutes, not hours. Don’t get stuck filling in tedious form",
	},
	{
		icon: "fa-solid fa-dollar-sign",
		title: "Affordable Prices",
		desc: "We don’t want you worrying about high monthly costs. Our prices may be low, but we still offer the best coverage possible",
	},
	{
		icon: "fa-solid fa-user",
		title: "People First",
		desc: "Our plans aren’t full of conditions and clauses to prevent payouts. We make sure you’re covered when you need it",
	},
];
